"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createApolloClient = void 0;
const apolloClient_1 = require("src/apolloClient");
const assetsMetadataMerge = (existing, incoming) => {
    var _a, _b, _c;
    if (!existing)
        return incoming;
    if (!incoming)
        return existing;
    // Merge nested asset arrays instead of replacing
    return {
        __typename: existing.__typename,
        documents: (_a = incoming.documents) !== null && _a !== void 0 ? _a : existing.documents,
        drawings: (_b = incoming.drawings) !== null && _b !== void 0 ? _b : existing.drawings,
        softwares: (_c = incoming.softwares) !== null && _c !== void 0 ? _c : existing.softwares,
    };
};
const cacheConfig = {
    typePolicies: {
        Query: {
            fields: {
                assetsMetadata: {
                    merge: assetsMetadataMerge,
                },
            },
        },
    },
};
const createApolloClient = (portfolioApiUrl, culture) => (0, apolloClient_1.createApolloClient)(portfolioApiUrl, culture, cacheConfig);
exports.createApolloClient = createApolloClient;
